'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "target", "onUpdate", "onLinkTypeChange", "trackLinkUsageProps"];
import PropTypes from 'prop-types';
import getComponentName from 'react-utils/getComponentName';
import { LinkTypes } from 'rich-text-lib/constants/link';
import { HS_INPAGE } from '../constants/hsSettings';
import { getOpenFilePickerInpage } from '../utils/inpage';
import { trackInteraction } from '../utils/usageTracking';
import { getOpenFilePicker } from '../utils/file';
import { getSelectedLink, getLinkAttrProps, adaptLinkPropsToAttr, cleanLinkAttributes, removeLink, updateLinkInfo } from '../utils/link';
import { getFetchAnchors } from '../utils/anchor';
import { getFetchFileByUrl } from 'tinymce-data/api/FileManager';
import { getFetchContentPageList, getFetchPageBySlug, getFetchMeetingBySlug, getFetchMeetingsByUsers } from 'tinymce-data/api/Content';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
const withLinkControl = WrappedComponent => {
  function WithLinkControl(props) {
    const {
        editor,
        target,
        onUpdate,
        onLinkTypeChange,
        trackLinkUsageProps
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    const {
      apiClient,
      scopes,
      userId
    } = editor.settings;
    const handleUpdate = linkUpdate => {
      const linkOptions = adaptLinkPropsToAttr(linkUpdate);
      updateLinkInfo(editor, target, linkOptions);
      onUpdate(linkUpdate);
    };
    const handleLinkTypeChange = linkType => {
      if (linkType === LinkTypes.NONE) {
        removeLink(editor, target);
      }
      onLinkTypeChange(linkType);
    };
    const trackLinkUsage = (trackingAction, trackingValues) => {
      trackInteraction(editor, 'tinymceLink', trackingAction, Object.assign({}, trackingValues, trackLinkUsageProps));
    };
    const linkAttributes = cleanLinkAttributes(getLinkAttrProps(editor, getSelectedLink(editor.$(target))));
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
      scopes: scopes,
      userId: userId,
      onUpdate: handleUpdate,
      onLinkTypeChange: handleLinkTypeChange,
      fetchFileByUrl: getFetchFileByUrl(apiClient),
      fetchPageBySlug: getFetchPageBySlug(apiClient),
      fetchMeetingsByUsers: getFetchMeetingsByUsers(apiClient),
      fetchMeetingBySlug: getFetchMeetingBySlug(apiClient),
      fetchAnchors: getFetchAnchors(editor),
      fetchPages: getFetchContentPageList(apiClient),
      onSelectFile: editor.settings[HS_INPAGE] ? getOpenFilePickerInpage(editor) : getOpenFilePicker(editor),
      trackLinkUsage: trackLinkUsage,
      target: target
    }, linkAttributes, rest));
  }
  WithLinkControl.propTypes = {
    editor: PropTypes.object.isRequired,
    target: PropTypes.any,
    useNoLinkOption: PropTypes.bool,
    allowAnchorLinks: PropTypes.bool,
    allowFileDownload: PropTypes.bool,
    allowMeetingLink: PropTypes.bool,
    onUpdate: PropTypes.func,
    onLinkTypeChange: PropTypes.func,
    showRefAndTargetControls: PropTypes.bool,
    fetchPageBySlug: PropTypes.func,
    fetchMeetings: PropTypes.func,
    fetchMeetingBySlug: PropTypes.func,
    fetchAnchors: PropTypes.func,
    fetchPages: PropTypes.func,
    trackLinkUsage: PropTypes.func,
    trackLinkUsageProps: PropTypes.object,
    dropdownClassName: PropTypes.string
  };
  WithLinkControl.defaultProps = {
    useNoLinkOption: true,
    allowAnchorLinks: true,
    allowFileDownload: true,
    allowMeetingLink: true,
    onUpdate: noop,
    onLinkTypeChange: noop,
    dropdownClassName: 'mce-ui-select'
  };
  WithLinkControl.displayName = `WithLinkControl(${getComponentName(WrappedComponent)})`;
  return WithLinkControl;
};
export default withLinkControl;